module.exports = __webpack_public_path__ + "img/1503951970.fc28c287.jpg";